import React, { useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  revalidateAvailability,
  updateAvailability,
} from "../../store/availability/actions";
import { getMetrics, updateMetric } from "../../store/metrics/actions";
import { resetObj } from "../../store/operator/actions";
import { resetHeaderObj } from "../../store/header/actions";
import { setInitialStateManagerPanel } from "../../store/manager/actions";
import { logoutUser } from "../../store/auth/login/actions";
import { useHistory } from "react-router-dom";
import toastr from "toastr";
import { useTranslation } from "react-i18next";
import { getAvailability } from "../../Libs/CustomMethods/customMethods";

const Routines = () => {
  const { Authorization, availabilities } =
    useSelector((state) => state.Login.data) || {};
  const { connSignalR } = useSelector((state) => state.SignalR);
  const messageOperator = useSelector(
    (state) => state.Operator.messageOperator
  );
  const activeAvailabilityId = useSelector(
    (state) => state.Availability.activeAvailability
  );

  const activeAvailability = useMemo(() => {
    if (activeAvailabilityId) {
      return getAvailability(availabilities, activeAvailabilityId);
    }
    return null;
  }, [availabilities, activeAvailabilityId]);

  const chats = messageOperator.chats?.data || [];

  const { success } = useSelector((state) => state.SignalR?.connSignalR) || {};
  const [timer, setTimer] = React.useState(null);

  const metricsStatus = useSelector((state) => state.Metrics?.status) || {};

  const interval = useRef(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showToast = (type, message) => {
    toastr.options = {
      closeButton: false,
      debug: false,
      newestOnTop: false,
      progressBar: true,
      positionClass: "toast-top-right",
      preventDuplicates: true,
      onclick: null,
      showDuration: "200",
      hideDuration: "200",
      timeOut: "60000",
      extendedTimeOut: "60000",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
    };
    toastr[type](message);
  };

  const handleLogout = () => {
    dispatch(resetObj());
    dispatch(resetHeaderObj());
    dispatch(setInitialStateManagerPanel());
    dispatch(logoutUser(history, true));
    localStorage.removeItem("status");
  };

  const updateLastPingUser = async () => {
    const avail = await localStorage.getItem("status");
    try {
      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/user/lastping`
      );

      if (response.status !== 200) {
        throw response.data;
      }

      const avail_id = response.data.data.availability_id;

      if (!avail_id) {
        showToast(
          "error",
          t("You have been disconnected due to no connection. login again")
        );
        handleLogout();
      }

      const availability = getAvailability(availabilities, avail_id);

      if (availability?.id !== activeAvailabilityId) {
        dispatch(revalidateAvailability(availability?.id));
      }
    } catch (error) {
      throw error;
    }
    dispatch(getMetrics());
  };

  useEffect(() => {
    if (!messageOperator.chats?.message) return;

    const hasActiveConversations = chats?.find(
      (cv) => cv.status === "active" || cv.status === "inactive"
    );

    if (!hasActiveConversations && activeAvailability) {
      if (activeAvailability?.associatedPauseId) {
        const associatedPause = getAvailability(
          availabilities,
          activeAvailability.associatedPauseId
        );

        if (associatedPause) {
          dispatch(
            updateAvailability(
              { availability_id: associatedPause.id },
              associatedPause?.typeInfo
            )
          );
        }
      }
    }
  }, [messageOperator, connSignalR]);

  useEffect(() => {
    if (!Authorization) return;

    updateLastPingUser();
    interval.current = setTimeout(() => setTimer(new Date()), 120000);

    return () => {
      interval.current && clearTimeout(interval.current);
    };
  }, [Authorization, timer]);

  useEffect(() => {
    if (success) {
      updateLastPingUser();
    }
  }, [success]);

  useEffect(() => {
    if(!activeAvailabilityId) return;
    if (metricsStatus.success) {
      dispatch(updateMetric(new Date()));
    }
  }, [activeAvailabilityId]);

  return <></>;
};

export default Routines;
